import { createFileRoute } from '@tanstack/react-router';

import { ReportProTipsPage } from '@/features/settings/ReportProTipsPage';

export const Route = createFileRoute('/admin/_app/platform-settings/report-pro-tips')({
  component: ReportProTipsPage,
});
